<div #left
     class="actions left"
     [class.panning]="panningDirection === 'left'"
     [class.single]="leftActions.length === 1"
     [class.active]="active">
  <ng-content select="[cui-swipeable-action=left]"></ng-content>
  <div class="chevron">
    <mat-icon svgIcon="icon/chevron-right-white"></mat-icon>
  </div>
</div>

<div class="item" #item [class.panning]="panning">
  <ng-content></ng-content>
</div>

<div #right
     class="actions right"
     [class.panning]="panningDirection === 'right'"
     [class.single]="rightActions.length === 1"
     [class.active]="active">
  <div class="chevron">
    <mat-icon svgIcon="icon/chevron-left-white"></mat-icon>
  </div>
  <ng-content select="[cui-swipeable-action=right]"></ng-content>
</div>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/swipeable/swipeable.component.html